import { Star } from 'lucide-react';
import { useState } from 'react';

interface RatingInputProps {
  disabled: boolean;
  label?: string;
}

export const RatingInput = ({ disabled, label }: RatingInputProps) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);

  // Extract rating range from label (e.g., "Rating (1-7 stars)" -> 7)
  const extractRatingRange = (labelText?: string): number => {
    if (!labelText) return 5;
    const match = labelText.match(/\(?\s*(\d+)\s*[-–—to]+\s*(\d+)\s*\)?/i);
    if (match) {
      const max = parseInt(match[2], 10);
      return max >= 1 && max <= 10 ? max : 5;
    }
    return 5;
  };

  const maxRating = extractRatingRange(label);

  return (
    <div className="space-y-2">
      <div className="flex gap-1 flex-wrap">
        {Array.from({ length: maxRating }, (_, i) => i + 1).map((star) => (
          <button
            key={star}
            type="button"
            disabled={disabled}
            onClick={() => !disabled && setRating(star)}
            onMouseEnter={() => !disabled && setHover(star)}
            onMouseLeave={() => !disabled && setHover(0)}
            className="p-0.5 transition-transform hover:scale-110 disabled:cursor-default"
          >
            <Star
              size={28}
              className={`transition-colors ${
                star <= (hover || rating) ? 'fill-[#C0275E] text-[#C0275E]' : 'text-gray-300'
              }`}
            />
          </button>
        ))}
      </div>
      {rating > 0 && (
        <p className="text-sm text-[#621C43] font-medium">
          Selected: {rating}/{maxRating} star{rating > 1 ? 's' : ''}
        </p>
      )}
    </div>
  );
};
